import {
    createFetchReducer,
    INITIAL_FETCH_STATE
} from '../../../middleware';
import { NotificationsState } from './notifications.types';

export const FETCH_NOTIFICATIONS = 'notifications';

export const INITIAL_NOTIFICATIONS_STATE: NotificationsState = INITIAL_FETCH_STATE;

export const getNotificationsReducer = () => {
    return createFetchReducer(
        FETCH_NOTIFICATIONS,
        INITIAL_NOTIFICATIONS_STATE
    );
};
